import React from 'react';
import LinkButtonRender,{LinkButtonProps} from './LinkButtonRender';

export const LinkButton=({...props}:LinkButtonProps):JSX.Element=>{
	
	return <LinkButtonRender {...props}/>;
};
